# Tower Pro 弹窗

$ ->

  $(document.body).on 'click', '*[data-tower-pro]', ->
    $el = $(@)
    feature = $el.data 'tower-pro'
    return if feature == 'header-upgrade-ad'

    tower.showProPopover $el,
      feature: feature,
      has_trial_choice: $el.data('has-trial-choice'),
      desc: $el.data('desc'),
      url: $el.data('feature-url'),
      center: $el.data('center')
      position: $el.data('position')

    $.ajax
      url: '/log_behavior',
      type: 'POST',
      dateType: 'json',
      data:
        resource_type: 'CallToAction',
        behavior_action: 'show',
        extra_values:
          name: feature

    return false


$.extend tower,
  showProPopover: ($el, opts = {}) ->
    feature = opts.feature
    if opts.url
      link = """<a href="#{opts.url}" class="btn btn-large" data-stack data-stack-root>查看功能介绍</a>"""
    else
      url = if tower.team.guid then "/teams/#{tower.team.guid}/upgrade/?cta_name=#{feature}" else '/plans'
      link =
        if opts.has_trial_choice
          """<a href="#{url}" class="btn btn-large">免费试用</a>"""
        else
          """<a href="#{url}" class="btn btn-large" data-stack data-stack-root>立即升级</a>"""

    tpl = """
      <div class="pro-main">
        <div class="pro-feature" data-type="#{feature}"></div>
        <p class="pro-text">#{opts.desc || '升级更高版本可解锁该功能。'}</p>
      </div>
      <div class="button-wrap">#{link}</div>
    """

    simple.popover
      pointTo: $el
      content: tpl
      position: opts.position
      cls: "popover-tower-pro #{'popover-tower-pro-center' if opts.center}"

  showUploadFileSizeLimitProPopover: ->
    simple.dialog.removeAll()
    translateFilesize = (filesize) =>
      if filesize >= 1048576
        return "#{Math.ceil(filesize / 1048576)} TB"
      else if filesize >= 1024
        return "#{Math.ceil(filesize / 1024)} GB"
      else
        return "#{filesize} MB"
    tower.showProPopover $(document.body),
      feature: 'upload_file_size_limit',
      desc: "基础版团队单个文件最大支持 #{translateFilesize(window.gon.upload_file_size_limit)}，升级到更高版本单个文件最大支持 #{translateFilesize(window.gon.max_upload_file_size_limit)}",
      center: true,
      has_trial_choice: window.gon.has_trial_choice

  showTrialTeamSurpassMembersLimit: ->
    tpl = '
      <div class="pro-main">
        <div class="pro-feature" data-type="trial-surpass-members-limit"></div>
        <p class="pro-title">你的团队成员数已满 10 人</p>
        <p class="pro-text"><strong>你仍可邀请新成员。</strong>但试用期结束后如未续费，超出 10 人的成员将无法登录此团队。</p>
      </div>
      <div class="button-wrap">
        <a href="javascript:;" class="btn btn-huge">知道了</a>
      </div>
    '
    # dialog = simple.dialog
    #   width: 460
    #   showRemoveButton: false
    #   content: tpl
    #   modal: true
    #   buttons: null
    #   cls: 'dialog-tower-pro'

    # dialog.el.on 'click', '.btn', ->
    #   dialog.remove()

  showProDialog: (plan) ->
    tpl = """
      <div class="pro-main">
        <div class="pro-feature" data-type="success"></div>
        <div class="pro-feature-title">欢迎使用 Tower #{plan}</div>
        <p class="pro-text">团队已成功升级到#{plan}。你和其它成员现在就可以使用#{plan}的高级功能了！</p>
      </div>
      <div class="button-wrap">
        <a href="/plans" class="btn btn-huge" target="_blank">了解#{plan}新功能</a>
      </div>"""

    dialog = simple.dialog
      width: 430
      cls: 'dialog-tower-pro'
      showRemoveButton: false
      content: tpl
      modal: true
      buttons: null

    dialog.el.on 'click', '.btn', ->
      dialog.remove()

  showProRemindDialog: (team, url, plan) ->
    tpl = """
      <div class="pro-main">
        <div class="pro-feature-title">请尽快续费</div>
        <p class="pro-text">#{team} 的#{plan}方案将在 7 天内到期，为了团队的正常工作，请尽快续费。</p>
        <ul>
          <li>支持支付宝付款，可以开具合同及发票；</li>
          <li>支持对公转账付款，可以开具合同及发票；</li>
          <li>购买多年享受优惠折扣。</li>
        </ul>
      </div>
      <div class="button-wrap">
        <a href="#{url}" class="btn btn-huge" data-stack data-stack-root>立即续费</a>
      </div>"""

    dialog = simple.dialog
      width: 460
      cls: 'dialog-tower-pro'
      content: tpl
      modal: true
      clickModalRemove: false
      buttons: null

  showDowngradeDialog: ->
    tpl = """
      <div class="pro-main">
        <div class="pro-feature" data-type="downgrade"></div>
        <div class="pro-feature-title">当前团队已降级为免费版</div>
        <p class="pro-text">由于免费版最多允许添加 10 位成员，超出限额的成员账号将会限制登录到该团队。你可以在团队成员列表页面查看访问受限的成员。</p>
        <p class="pro-text">同时，你与你的团队成员将不再享受无限项目、更大的存储空间、任务高级筛选、项目统计等诸多功能。</p>
        <p class="pro-text">立即升级为付费版可重新启用这些功能。</p>
      </div>
      <div class="button-wrap">
        <a href="/plans" class="btn btn-huge" data-stack data-stack-root>了解 Tower 付费版</a>
      </div>
    """

    simple.dialog
      width: 500
      cls: 'dialog-tower-pro'
      content: tpl
      modal: true
      clickModalRemove: false
      buttons: null

  showProCouponDialog: (content)->
    dialog = simple.dialog
      width: 660
      cls: 'dialog-tower-pro-coupon dialog-tower-pro'
      content: content
      modal: true
      clickModalRemove: false
      buttons: null

  uploaderror: (xhr) ->
    return unless xhr.responseText

    result = {}
    try
      responseType = xhr.getResponseHeader("content-type")
      if responseType.indexOf("application/json") != -1
        result = JSON.parse xhr.responseText
      else if responseType.indexOf("application/xml") != -1
        responseXML = $.parseXML xhr.responseText
        result.msg = "抱歉，上传失败了。我们已经记录了错误，并会尽快修复，不妨稍后再试一下。"
        console.error($(responseXML).find('Message').text())
    catch e

    unless result.msg
      result.msg = '上传出错了'

    if result.msg is 'over_limit'
      simple.dialog.removeAll()
      tower.showProPopover($(document.body), {
        feature: 'storage',
        desc: '你的团队已经用完了存储空间，升级到更高版本可立即获得更多存储空间。',
        center: true,
        has_trial_choice: result.has_trial_choice
      });
    else if result.msg is 'tr_repository.plan_limit'
      simple.dialog.removeAll()
      tower.showProPopover($(document.body), {
        feature: 'repository',
        desc: '知识库文档数量已达上限，升级到付费版可解锁该限制。',
        center: true,
        has_trial_choice: result.has_trial_choice
      });
    else
      simple.dialog.message
        content: result.msg
